import React, { useState, useEffect } from 'react';

import { ProductController } from "controllers";

// components
import { DamageReport } from 'shared/components/product';

const Reports = ({ barcode }) => {
    const [reports, setReports] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            const result = await ProductController.getReportsByBarcode(barcode);
            setReports(result);
        }

        fetchData();
    }, [barcode]);

    return (
        <DamageReport className="is-fullwidth" data={reports} />
    );
}

export default Reports;
